/* ==============================================================
 * templates/tenant-single
 * ============================================================== */
(function ($) {
  "use strict";
  console.log("tenant-single iniciado");

  /* ------------------------------------------------------------
   *  FLAGS AND CONSTANTS
   * ---------------------------------------------------------- */
  const EXTRA_MOBILE_ZOOM = 5;
  const isMobile = window.matchMedia("(pointer:coarse)").matches;

  /* ============================================================
   *  BOOTSTRAP – POPOVERS
   * ========================================================== */
  document.addEventListener("DOMContentLoaded", () => {
    const lockPage = (e) => document.body.classList.add("popover-open");
    const unlockPage = () => document.body.classList.remove("popover-open");

    /* -------------------------------------------------------------- */
    /* POP-OVERS                                          */
    /* -------------------------------------------------------------- */
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
      new bootstrap.Popover(el); // garante instância

      el.addEventListener("show.bs.popover", lockPage);
      el.addEventListener("hidden.bs.popover", unlockPage);
    });

    const htmlContentEl = document.getElementById("popover-html-content");
    if (htmlContentEl) {
      $("#html-popover").on("click", (e) => e.preventDefault());

      const popHtml = new bootstrap.Popover(
        document.getElementById("html-popover"),
        {
          content: htmlContentEl.innerHTML,
          html: true,
          trigger: "hover",
          placement: "bottom",
          customClass: "popover-wide",
          offset: [300, 0],
        }
      );

      const triggerEl = document.getElementById("html-popover");
      triggerEl.addEventListener("show.bs.popover", lockPage);
      triggerEl.addEventListener("hidden.bs.popover", unlockPage);
    }
  });

  /* ============================================================
   *  SLICK SLIDER
   * ========================================================== */
  if (typeof SLICK_CONFIG !== "undefined") {
    $(".center").slick({
      centerMode: true,
      arrows: true,
      variableWidth: true,
      prevArrow: `<button type="button" class="slick-left  custom-arrow"><img src="${SLICK_CONFIG.arrowLeft}"  alt="Prev"></button>`,
      nextArrow: `<button type="button" class="slick-right custom-arrow"><img src="${SLICK_CONFIG.arrowRight}" alt="Next"></button>`,
      autoplay: true,
      // centerPadding: "100px", // Reduced from 200px
      // slidesToShow: 3,
      infinite: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
          },
        },
      ],
    });
  } else {
    console.error("SLICK_CONFIG is undefined — arrow SVG paths not passed.");
  }

  /* ============================================================
   *  GSAP – HERO ANIMATION
   * ========================================================== */
  $(document).ready(() => {
    const $hero = $(".hero-area-test").first();
    if (!$hero.length) return;

    gsap
      .timeline({ defaults: { ease: "power3.out" } })
      .to($hero, { duration: 0.6, scale: 1, opacity: 1 })
      .to(
        ".hero-area__headline",
        { duration: 1.5, y: 0, opacity: 1, stagger: 0.25 },
        "-=0.8"
      );
    gsap
      .timeline({ defaults: { ease: "power3.out" } })
      .to($hero, { duration: 0.6, scale: 1, opacity: 1 })
      .to(
        ".description p",
        { duration: 1.5, y: 0, opacity: 1, stagger: 0.25 },
        "-=0.8"
      );
  });

  /* ------------------------------------------------------------
   *  CARD
   * ---------------------------------------------------------- */
  const $card = $("#storeCardSingle").css({
    position: "fixed",
    zIndex: 9999,
    pointerEvents: "auto",
    transform: "translate(-50%,0)",
    display: "none",
  });

  const stores = window.mallMapData || {};
  const clamp = (v, min, max) => Math.max(min, Math.min(v, max));

  const viewPos = (ev) =>
    ev.pointerType
      ? { x: ev.clientX, y: ev.clientY } // Pointer events
      : ev.changedTouches
      ? { x: ev.changedTouches[0].clientX, y: ev.changedTouches[0].clientY } // Touch
      : { x: ev.clientX, y: ev.clientY }; // Mouse

  /* ---- click/touch on every store ---------------------------------------- */
  $("#map-wrapper svg .store").on("pointerup", function (ev) {
    //ev.stopPropagation();

    const meta = stores[this.id] || {};
    if (!meta.t1) return;

    $("#cardImgSingle")
      .toggle(!!meta.img)
      .attr("src", meta.img || "");
    $("#cardBtnSingle .btn-label").text(meta.btn || "Details");

    // Check if there's a valid URL (not empty, not just whitespace, not just "#")
    const hasValidUrl =
      meta.url && meta.url.trim() !== "" && meta.url.trim() !== "#";

    if (hasValidUrl) {
      $("#cardBtnSingle").attr("href", meta.url).removeClass("d-none").show();
    } else {
      $("#cardBtnSingle").addClass("d-none");
    }

    $("#cardT1").text(meta.t1);
    $("#cardT2").text(meta.t2 || "");
    $("#cardT3").text(meta.t3 || "");

    /* --- NEW anchor = text label bounding-box ------------------- */
    const label = ev.currentTarget.querySelector("text");
    if (!label) return; // safety

    const rect = label.getBoundingClientRect(); // screen coords
    const x = rect.left + rect.width / 2; // centred
    const y = rect.bottom;
    const gap = 16;
    const h = $card.outerHeight();
    const w = $card.outerWidth();
    const vw = window.innerWidth;

    let top = y + gap;
    if (top + h > window.innerHeight) top = y - h - gap;
    const left = clamp(x, w / 2, vw - w / 2);

    $card.css({ left, top }).fadeIn(150);
  });

  /* Tap/click fora esconde */
  //$(document).on("pointerup", () => $card.fadeOut(100));
  $(document).on("pointerup", function (ev) {
    const $t = $(ev.target);
    if (
      !$t.closest(".store").length && // not a store
      !$t.closest("#storeCardSingle").length // not the card itself
    ) {
      $card.fadeOut(100);
    }
  });

  (function () {
    const $card = $("#storeCardSingle");

    const hideStoreCard = () => {
      $card.fadeOut(100);
      document
        .querySelectorAll('[data-bs-toggle="popover"]')
        .forEach((el) => bootstrap.Popover.getInstance(el)?.hide());
    };

    window.addEventListener("scroll", hideStoreCard, { passive: true });

    // window.addEventListener("wheel", hideStoreCard, { passive: true });
  })();

  // /* ------------------------------------------------------------
  //  *  FUNCTION OF INITIAL FOCUS
  //  * ---------------------------------------------------------- */
  // function focusOn(id) {
  //   const el = document.getElementById(id);
  //   if (!el) return;

  //   const box = el.getBBox();
  //   const cx = box.x + box.width / 2;
  //   const cy = box.y + box.height / 2;
  //   const view = pzs.getSizes();
  //   const ratio = Math.max(view.width / box.width, view.height / box.height);
  //   const baseZoom = ratio / 3.2;
  //   const targetZoom = isMobile ? baseZoom * EXTRA_MOBILE_ZOOM : baseZoom;

  //   pzs.zoom(targetZoom);

  //   const real = pzs.getSizes().realZoom;
  //   pzs.pan({ x: view.width / 2 - cx * real, y: view.height / 2 - cy * real });
  // }

  /* ============================================================
   *  MAP (svgPanZoom)
   * ========================================================== */
  
  // Ensure this runs after DOM is ready and layout is complete
  $(document).ready(() => {
    // Wait for images and other resources to load, then initialize
    if (document.readyState === 'complete') {
      initializeMap();
    } else {
      window.addEventListener('load', () => {
        setTimeout(initializeMap, 100); // Small delay for layout computation
      });
    }
  });

  function initializeMap() {
    if ($("#map-wrapper").length && $(".templates-tenant-single-page").length) {
      console.log("svgPanZoom tenant-single…");

      const EXTRA_MOBILE_ZOOM = 4;
      const isMobile = window.matchMedia("(pointer:coarse)").matches;

      const wrapper = document.getElementById("map-wrapper");
      const svgEl = wrapper.querySelector("svg");
      if (!svgEl) {
        console.warn("No SVG found in map-wrapper");
        return;
      }
      
      // Ensure container has dimensions before initializing
      if (!wrapper.offsetWidth || !wrapper.offsetHeight) {
        console.log("Container not ready, retrying...");
        setTimeout(initializeMap, 200);
        return;
      }
    
    wrapper.style.touchAction = "none"; // stops the browser from hijacking pinch
    svgEl.style.touchAction = "none";

    // Function to properly cover and center the SVG (like CSS cover)
    const coverAndCenterMap = (panZoomInstance) => {
      if (!panZoomInstance) return;
      
      try {
        // Reset any previous transformations
        panZoomInstance.resetPan();
        panZoomInstance.resetZoom();
        
        // Use contain() for CSS cover-like behavior (fills entire container)
        panZoomInstance.contain();  // This fills the container like CSS cover
        panZoomInstance.center();   // Center the SVG
        
        const currentZoom = panZoomInstance.getZoom();
        console.log(`Map set to cover mode with zoom level: ${currentZoom.toFixed(2)}`);
      } catch (error) {
        console.warn("Error covering map:", error);
      }
    };

    const pzs = svgPanZoom(svgEl, {
      zoomEnabled: true,
      mouseWheelZoomEnabled: false, // ctrl/⌘ vai ligar isso
      controlIconsEnabled: false,
      fit: false,     // We'll handle fitting manually for better control
      center: false,  // We'll handle centering manually
      contain: true,  // Enable contain mode for CSS cover-like behavior
      minZoom: 0.1,   // Very low minimum to allow proper cover scaling
      maxZoom: 12,
      customEventsHandler: {
        haltEventListeners: [
          "touchstart",
          "touchmove",
          "touchend",
          "touchcancel",
        ],

        init() {
          /* ------------------------------------------------------
           *  Hammer manager: Pan (1-finger), Pinch (2-finger) + Tap
           * ---------------------------------------------------- */
          const ham = new Hammer.Manager(wrapper, { touchAction: "none" });
          const pan = new Hammer.Pan({
            direction: Hammer.DIRECTION_ALL,
            threshold: 0,
          });
          const pinch = new Hammer.Pinch({ threshold: 0, pointers: 2 });
          const tap = new Hammer.Tap({ taps: 2 });

          ham.add([pan, pinch, tap]);
          pinch.recognizeWith([pan, tap]); // gestures can coexist

          /* ------------ single-finger drag (Pan) ------------- */
          let panStart = { x: 0, y: 0 };
          ham.on("panstart", (ev) => {
            if (ev.target.closest(".store")) return; // clicking a store? let popup logic run
            panStart = pzs.getPan();
            wrapper.classList.add("grabbing");
          });

          ham.on("panmove", (ev) => {
            if (ev.target.closest(".store")) return;
            const z = pzs.getSizes().realZoom || 1;
            pzs.pan({
              x: panStart.x + ev.deltaX / z,
              y: panStart.y + ev.deltaY / z,
            });
          });

          ham.on("panend", () => wrapper.classList.remove("grabbing"));

          /* --------------- pinch-to-zoom --------------------- */
          let startZoom = 1;
          ham.on("pinchstart", () => {
            startZoom = pzs.getZoom();
            wrapper.classList.add("grabbing");
          });

          ham.on("pinchmove", (ev) => {
            ev.preventDefault(); // stop browser page-zoom
            const newZoom = startZoom * ev.scale;

            /* zoom about the gesture centre */
            const rect = svgEl.getBoundingClientRect();
            const point = {
              x: ev.center.x - rect.left,
              y: ev.center.y - rect.top,
            };
            pzs.zoomAtPoint(newZoom, point);
          });

          ham.on("pinchend", () => wrapper.classList.remove("grabbing"));

          /* --------------- double-tap reset ------------------ */
          ham.on("doubletap", (ev) => {
            if (ev.target.closest(".store")) return; // ignore taps on stores
            pzs.resetZoom();
            pzs.center();
          });

          /* keep a reference so svg-pan-zoom can destroy it */
          this.hammer = ham;
        },

        destroy() {
          this.hammer && this.hammer.destroy();
        },
      },
    });

    /* ------------------------------------------------------------
     *  EXECUTE FOCUS WHEN SVG EXIST
     * ---------------------------------------------------------- */
    // document.addEventListener("DOMContentLoaded", () => {
    //   const target = window.mallMapConfigSingle?.initialStore; // p.ex. "store-8"
    //   if (!target) return;

    //   const wait = () =>
    //     document.getElementById(target)
    //       ? focusOn(target)
    //       : requestAnimationFrame(wait);
    //   wait();
    // });

    /* ---------- min / max dinamic ---------- */
    // Initial cover and center - do this after pan-zoom is fully initialized
    setTimeout(() => {
      coverAndCenterMap(pzs);
      
      // Set dynamic min/max zoom based on current zoom level after cover
      const currentZoom = pzs.getZoom();
      const fitZoom = pzs.getSizes().fit; // Still use fit for minimum zoom reference
      
      if (Number.isFinite(currentZoom) && currentZoom > 0) {
        // Allow zooming out to fit level (CSS contain behavior) as minimum
        pzs.setMinZoom(Number.isFinite(fitZoom) ? fitZoom * 0.8 : currentZoom * 0.5);
        pzs.setMaxZoom(currentZoom * 8); // Max zoom relative to cover zoom
        
        // Re-apply cover after setting new zoom limits
        coverAndCenterMap(pzs);
      }
    }, 50);

    /* ---------- lock pan ---------- */
    pzs.setBeforePan((oldPan, newPan) => {
      const s = pzs.getSizes();
      if (!Number.isFinite(s.realZoom)) return oldPan;

      const z = s.realZoom;
      const left = s.width - s.viewBox.width * z;
      const top = s.height - s.viewBox.height * z;
      return {
        x: Math.min(0, Math.max(left, newPan.x)),
        y: Math.min(0, Math.max(top, newPan.y)),
      };
    });

    /* ---------- resize handler to re-cover map ---------- */
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        try {
          console.log("Handling window resize - re-covering map");
          
          // Resize the pan-zoom instance to match new container dimensions
          pzs.resize();
          
          // Re-cover and center the map in the new container size
          coverAndCenterMap(pzs);
          
          // Update zoom limits based on new cover zoom
          const currentZoom = pzs.getZoom();
          const fitZoom = pzs.getSizes().fit;
          
          if (Number.isFinite(currentZoom) && currentZoom > 0) {
            pzs.setMinZoom(Number.isFinite(fitZoom) ? fitZoom * 0.8 : currentZoom * 0.5);
            pzs.setMaxZoom(currentZoom * 8);
          }
        } catch (error) {
          console.warn("Error handling resize:", error);
        }
      }, 250); // Debounce resize events
    };
    
    window.addEventListener('resize', handleResize);
    
    // Also handle orientation changes on mobile
    window.addEventListener('orientationchange', () => {
      setTimeout(handleResize, 500); // Longer delay for orientation change
    });

    /* ========================================================
     *  ZOOM BUTTONS (+ / –)
     * ====================================================== */
    const controls = document.createElement("div");
    controls.className = "map-zoom-controls";

    const svgPlus = `
    <svg width="28" height="24" viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M7.09 12.18H11.82M11.82 12.18H16.55M11.82 12.18V16.91M11.82 12.18V7.45
               M11.82 22.82C5.94 22.82 1.18 18.06 1.18 12.18
               C1.18 6.31 5.94 1.55 11.82 1.55
               C17.69 1.55 22.45 6.31 22.45 12.18
               C22.45 18.06 17.69 22.82 11.82 22.82Z"
            stroke="white" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"/>
    </svg>`;

    const svgMinus = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M7.09 11.82H16.55
               M11.82 22.45C5.94 22.45 1.18 17.69 1.18 11.82
               C1.18 5.94 5.94 1.18 11.82 1.18
               C17.69 1.18 22.45 5.94 22.45 11.82
               C22.45 17.69 17.69 22.45 11.82 22.45Z"
            stroke="white" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"/>
    </svg>`;

    controls.innerHTML = `
    <button class="zoom-btn zoom-in"  aria-label="Zoom in">${svgPlus}</button>
    <button class="zoom-btn zoom-out" aria-label="Zoom out">${svgMinus}</button>`;
    wrapper.appendChild(controls);

    controls
      .querySelector(".zoom-in")
      .addEventListener("click", () => pzs.zoomIn());
    controls
      .querySelector(".zoom-out")
      .addEventListener("click", () => pzs.zoomOut());

    /* ========================================================
     *  OVERLAY “Hold Ctrl / ⌘ and scroll to zoom”
     * ====================================================== */
    const hint = document.createElement("div");
    hint.id = "zoomHint";
    hint.innerHTML =
      "Hold <strong>Ctrl</strong> (Windows) or <strong>⌘</strong> (Mac) and scroll to zoom";
    wrapper.appendChild(hint);

    const setHintVisible = (show) =>
      hint.classList.toggle("zoomHint--hide", !show);
    setHintVisible(true);
    pzs.disableMouseWheelZoom();

    document.addEventListener("keydown", (e) => {
      if (e.ctrlKey || e.metaKey) {
        pzs.enableMouseWheelZoom();
        setHintVisible(false);
      }
    });

    document.addEventListener("keyup", (e) => {
      if (!e.ctrlKey && !e.metaKey) {
        pzs.disableMouseWheelZoom();
        setHintVisible(true);
      }
    });

    /* ========================================================
     *  INITIAL FOCUS
     * ====================================================== */
    function focusOn(id, opts = {}) {
      const PADDING = opts.padding ?? 24; // px of free space
      const VIEWPORT_FACTOR = opts.viewportFill ?? 0.8; // 85 % of the screen
      const el = document.getElementById(id);
      if (!el) return;

      // 1 ⃣  Bounding box (+ padding on all sides)
      const box = el.getBBox();
      const targetW = box.width + PADDING * 2;
      const targetH = box.height + PADDING * 2;

      // 2 ⃣  Viewport size
      const view = pzs.getSizes(); // { width, height }

      // 3 ⃣  Scale so the target occupies VIEWPORT_FACTOR of the screen
      const zoomX = (view.width * VIEWPORT_FACTOR) / targetW;
      const zoomY = (view.height * VIEWPORT_FACTOR) / targetH;
      const targetZoom =
        Math.min(zoomX, zoomY) * (isMobile ? EXTRA_MOBILE_ZOOM : 1);

      pzs.zoom(targetZoom);

      // 4 ⃣  Center the element
      const real = pzs.getSizes().realZoom;
      const cx = box.x + box.width / 2;
      const cy = box.y + box.height / 2;
      pzs.pan({
        x: view.width / 2 - cx * real,
        y: view.height / 2 - cy * real,
      });
    }

    /* espera o SVG ter sido injetado */
    const target = window.mallMapConfigSingle?.initialStore;
    if (target) {
      const wait = () =>
        document.getElementById(target)
          ? focusOn(target)
          : requestAnimationFrame(wait);
      wait();
    }
    } // End of if condition
  } // End of initializeMap function
})(jQuery);
